import React from "react";
import logoReduzido from '../../assets/images/logotipo_tradicional_sacola_44.png';

const FooterWebPage = () => {
    return (
        <footer>
            <nav>
                <a href="/politicas-de-privacidade" >Política de Privacidade</a> |
                <a href="/termos-de-uso" >Termos de Uso</a> |
                <a href="/excluir-minha-conta">Excluir Minha Conta</a> |
                <a href="/dashboard">Área do Lojista</a>
            </nav>
            <p>Contato: <a href="mailto:contato@passarela44.com.br" target="_blank">contato@passarela44.com.br</a><br />
                WhatsApp: <a href="https://wa.me/5562993297065" target="_blank">(62) 99329-7065</a></p>
            <div className="social-icons">
                <a href="https://www.facebook.com/profile.php?id=61584491034541" target='_blank'><i className="fab fa-facebook"></i></a>
                <a href="https://www.instagram.com/passarela44oficial#" target='_blank'><i className="fab fa-instagram"></i></a>
                <a href="https://x.com/Passarela44" target='_blank'><i className="fab fa-x-twitter"></i></a>
            </div>
            <img src={logoReduzido} alt="Logo Passarela 44" className='img-logo-reduzido' />
            <p>Copyright Passarela 44 © 2026. Created by Creative IT Ltda.<br />Rua Coelho Neto, 21, Bairro Anhanguera, Goiânia - GO. CEP 74.335-060<br />CNPJ: 64.436.153/0001-69</p>
        </footer>
    )
}

export default FooterWebPage;